<!-- 回复模版设置 -->
<template>
  <div class="container">
    <el-card class="box-card">
      <div class="box-card-top">
        <p class="p1">自动回复设置</p>
        <div>
          <el-button @click="save">保存</el-button>
          <el-button @click="emptying">置空</el-button>
        </div>
      </div>
      <div class="top">
        <p class="p2">何种评价下（总分）采用如下模板作为自动回复的内容：</p>
        <el-radio-group v-model="saveDatas.label">
          <el-radio v-for="item in radioList" :key="item.label" :label="item.label">{{ item.value }}</el-radio>
        </el-radio-group>
      </div>
      <div class="bottom">
        <p class="p1"><span>*</span>模版内容</p>
        <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 4 }" placeholder="请输入内容" v-model="saveDatas.content">
        </el-input>
      </div>
      <p class="p3">提示： 若评论为较差/很差皆需手动回复</p>
    </el-card>
    <p style="margin-bottom:0.2rem">已有自动回复列表</p>
    <footer class="footer">
      <el-radio-group @change="evaluationTemplateList()" v-model="init.q.label" size="small">
        <el-radio-button v-for="item in radio2List" :key="item.label" :label="item.label">{{ item.value
        }}</el-radio-button>
      </el-radio-group>
      <div class="right">
        <el-button size="small">导出</el-button>
      </div>
    </footer>
    <el-table highlight-current-row v-loading="loading" :data="tableData" :header-cell-style="{ color: '#000' }"
      @selection-change="handleSelectionChange" @current-change="handleCurrentChange" style="width: 100%">
      <el-table-column align="center" type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="100" prop="date" label="适用评价"> 
        <template slot-scope="scope">
          <el-tag :type="radio2List.find(n => n.label == scope.row.label).type">{{ radio2List.find(n => n.label == scope.row.label).value }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="模版内容"> </el-table-column>
      <el-table-column align="center" width="100" prop="date" label="操作">
        <template slot-scope="scope">
          <el-button @click="handlerDeleteClick(scope.row)" type="primary" icon="el-icon-delete"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :currentPage="init.page" :pageSizes="pageSizes" :parentPageSize="10" :totalNumber="AllpagesNum"
      @loadTable='loadTable'></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import OrderApi from '@/components/Api/order'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      init: {
        "page": 1,
        "q": {
          "clientId": "",
          "content": "",
          "createCompanyId": null,
          "createCompanyName": "",
          "createId": null,
          "createName": "",
          "id": null,
          "label": null
        },
        "size": 10
      },
      saveDatasTel: {
        "clientId": "",//是哪个系统
        "content": "",//模版内容设置
        "createCompanyId": null,
        "createCompanyName": "",
        "createId": null,
        "createName": "",
        "id": null,
        "label": '5'
      },
      saveDatas: {
        "clientId": "",//是哪个系统
        "content": "",//模版内容设置
        "createCompanyId": null,
        "createCompanyName": "",
        "createId": null,
        "createName": "",
        "id": null,
        "label": '5'
      },
      pageSizes: [10, 20, 25, 30],
      loading: true,
      AllpagesNum: 0,
      tableData: [],
      radio2List: [
        {
          value: '全部',
          label: null
        },
        {
          value: '极力推荐',
          label: '5',
          type:'success'
        },
        {
          value: '超赞',
          label: '4',
          type:'success'
        },
        {
          value: '满意',
          label: '3',
          type:'success'
        },
        {
          value: '一般',
          label: '2',
          type:'info'
        },
        {
          value: '默认好评',
          label: '-1',
          type:'success'
        }
      ],
      radioList: [
        {
          value: '极力推荐',
          label: '5'
        },
        {
          value: '超赞',
          label: '4'
        },
        {
          value: '满意',
          label: '3'
        },
        {
          value: '一般',
          label: '2'
        },
        {
          value: '默认好评',
          label: '-1'
        }
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleSelectionChange() { },
    //模版列表
    evaluationTemplateList() {
      new OrderApi("order")
        .evaluationTemplate(this.init)
        .then((res) => {
          if (res.status == 200) {
            this.tableData = res.data.records
            this.AllpagesNum = res.data.total
            this.loading = false
          } else {
            this.$message.error({ message: res.statusText });
          }
        });
    },
    //置空
    emptying() {
      this.saveDatas = this.saveDatasTel
    },
    //单选进行修改操作
    handleCurrentChange(val) {
      if (val) {
        val.label = val.label.toString()
        this.saveDatas = JSON.parse(JSON.stringify(val))
      }
    },
    //删除模版
    handlerDeleteClick() {
     
    },
    //保存模版
    save() {
      new OrderApi("order")
        .saveOrUpdate(this.saveDatas)
        .then((res) => {
          if (res.status == 200) {
            this.evaluationTemplateList()
            this.$message.success(this.saveDatas.id ? '修改成功' : '保存成功')
            this.saveDatas = this.saveDatasTel
          } else {
            this.$message.error({ message: res.statusText });
          }
        });
    },
    loadTable(page, size) {
      this.init.size = size
      this.init.page = page
      this.loading = true
      this.evaluationTemplateList()
    },
  },
  created() { },
  mounted() {
    this.evaluationTemplateList()
  },
};
</script>
<style lang="scss" scoped>
.container {
  .box-card {
    margin-bottom: 0.2rem;

    .box-card-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .p1 {
      font-size: 0.2rem;
      margin-bottom: 0.1rem;
    }

    .top {
      display: flex;
      align-items: center;
      margin-bottom: 0.1rem;

      .p1 {
        font-size: 0.12rem;
        color: #303133;
        margin-right: 0.1rem;
      }
    }
  }

  .bottom {
    display: flex;
    margin-bottom: 0.2rem;

    .p1 {
      white-space: nowrap;
      font-size: 0.12rem;
      margin-right: 0.5rem;

      span {
        color: red;
      }
    }
  }

  .p3 {
    font-size: 0.12rem;
    color: red;
  }

  .footer {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;

    .right {
      margin-left: auto;
    }
  }
}
</style>
